import { CDN_URL } from "../utils/constants";

const Rescard = (props) => {
  const { resData } = props;
  const { cloudinaryImageId, name, locality, cuisines, avgRating } =
    resData?.card?.card?.info;

  return (
    <div className="res-card relative w-[280px] xs:w-[300px] sm:w-[350px] h-auto">
      <div className="res-img">
        <img 
          src={CDN_URL + cloudinaryImageId} 
          alt="Res -Img"
          className="w-[270px] xs:w-[290px] sm:w-[340px] h-[200px] xs:h-[250px] sm:h-[290px] object-cover m-1 xs:m-2 sm:m-5 p-2 xs:p-4 sm:p-9 rounded-[20px]" 
        />
      </div>
      <div className="res-card-content p-2 xs:p-3">
        <h3 className="font-bold text-base xs:text-lg sm:text-xl">{name || "Restaurant Name Not Available"}</h3>
        <h4 className="text-sm xs:text-base">{locality || "Near By location"}</h4>
        <h5 className="text-sm xs:text-base truncate">{cuisines.join(", ") || "N/A"}</h5>
        <h5 className="text-sm xs:text-base">Rating: {avgRating || "Good Rating"} ⭐</h5>
      </div>
    </div>
  );
};

export const withPromotedLabel = (ResCard) => {
  return (props) => {
    return (
      <div className="group hover:scale-103 hover:-translate-y-2 transition-transform duration-300 relative">
        <label className="absolute top-2 left-2 bg-slate-600 text-white text-xs xs:text-sm p-1 xs:p-2 z-50 shadow-lg rounded-lg">
          Promoted
        </label>
        <ResCard {...props} />
      </div>
    );
  };
};

export default Rescard;
